import { GetStaticProps } from 'next';
import React from 'react';
import { getStaticPropsAgents } from '@layout/get-page-props/agents/get-page-props-agents';
import { storeWrapper } from '@state/store';
import { withGlobalProvider } from 'providers/globalProvider';
import { withAgentLogin } from '@components/hoc/with-auth/with-auth';
import AgentsHomePageLayout from '@layout/agents/AgentsHomePageLayout';
import { AsyncData } from '@model/common';
import { AgentsPageProps } from '@model/common/pages/agent-pages';
import { Agent } from '@model/agents/agents-models';
import { Revalidate } from '@model/config/revalidate';
import { useSelector } from 'react-redux';
import { getAgent } from '@state/slices/agent/agentSelectors';

export const AgentsHomePage = (props: AgentsPageProps) => {
  const agent: AsyncData<Agent> = useSelector(getAgent);
  return <AgentsHomePageLayout {...props} agent={agent.data} />;
};

export const getStaticProps: GetStaticProps<any, any> = storeWrapper.getStaticProps((store) => async () => ({
  ...(await getStaticPropsAgents({ store, path: '' })),
  revalidate: Revalidate.HALF_HOUR
}));

export default withGlobalProvider(withAgentLogin(AgentsHomePage));
